import { DatePipe } from '@angular/common';
import { PipeTransform, Pipe, inject, LOCALE_ID } from '@angular/core';

@Pipe({
  name: 'dateTimeFormatTooltip'
})
export class DateTimeformatTooltip implements PipeTransform {
  private readonly datePipe = inject(DatePipe);
  private readonly locale = inject(LOCALE_ID);

  transform(value: string | Date | null): string | null {
    if (!value)
      return null;

    return this.datePipe.transform(value, 'MM/dd/yyyy h:mm a', undefined, this.locale) ?? '';
  }
}